import { IModuleManifest } from 'types';
import routes from './routes';

export const CreateNewAppModule: IModuleManifest = {
    name: 'create-new-app',
    version: '1.0.0',
    description: 'Create New App Module',
    routes,
    menuItems: [{
        id: 'create-new-app',
        label: 'app:menus.addApp',
        iconName: 'maa-create-new-app.solid',
        order: 200,
        data: {
            route: '/create-new-app'
        }
    }]
};
